/** 数据中心 → 萃茶机数据 → 智能精度（E1 客户报表 · patch 201） */
export const TEA_E1_PERFORMANCE_MENU_IDS = {
  page: 990416,
  enName: 'teaE1Performance',
  parentEnName: 'dataOfTeaExtractorMachine'
}



// WEBPACK FOOTER //
// ./src/constants/teaE1Performance.js